import { useSelector } from 'react-redux';

import * as S from './styled/ModalManager.styled';

const ModalManager = () => {
	const modals = useSelector((state) => state.modals);

	return (
		<S.Container
			className={
				Object.entries(modals)?.filter(([_, modal]) => modal.visible === false).length > 0 ? 'active' : ''
			}>
			<S.Wrapper id="modal-manager" className="modal-manager" />
		</S.Container>
	);
};

export default ModalManager;
